import { atom } from "jotai";

export const otpToken = atom<string>();
export const otpUsername = atom<string>();
